import { CdkDragEnd }       from '@angular/cdk/drag-drop';
import { TranslateService } from '@ngx-translate/core';

import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';

import { BookingDiaryJobDropModel }       from './typings/booking-diary.drag';
import { BookingDiaryUnassignedJobModel } from './typings/booking-diary.backlog';

import {
  CLICK_SUPPRESS_MS,
  DRAG_START_DELAY,
  RAIL_LIMIT
} from './booking-diary.layout';

// The bookings with no mechanic yet, beside the day: dragged onto a slot, split or cancelled
@Component({
  selector   : 'wor-booking-diary-unassigned-rail',
  template: require('./booking-diary.unassigned-rail.component.html')
})
export class BookingDiaryUnassignedRailComponent implements OnDestroy {
  @Input() colors : { [jobId : string] : string }         = {};
  @Input() isBusy : boolean                               = false;
  @Input() jobs   : Array<BookingDiaryUnassignedJobModel> = [];

  @Output() jobCancelled  : EventEmitter<BookingDiaryUnassignedJobModel> = new EventEmitter<BookingDiaryUnassignedJobModel>();
  @Output() jobDropped    : EventEmitter<BookingDiaryJobDropModel>       = new EventEmitter<BookingDiaryJobDropModel>();
  @Output() jobOpened     : EventEmitter<BookingDiaryUnassignedJobModel> = new EventEmitter<BookingDiaryUnassignedJobModel>();
  @Output() moreRequested : EventEmitter<void>                           = new EventEmitter<void>();

  dragStartDelay : { mouse : number; touch : number } = DRAG_START_DELAY;
  railLimit      : number                             = RAIL_LIMIT;

  private hasJustDragged : boolean = false;
  private resetTimer     : ReturnType<typeof setTimeout>;

  constructor (
    private translateService : TranslateService
  ) {}

  ngOnDestroy () : void {
    clearTimeout(this.resetTimer);
  }

  onCancel ( clickEvent : MouseEvent, job : BookingDiaryUnassignedJobModel ) : void {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();

    this.jobCancelled.emit(job);
  }

  // the card itself never moves; the preview does, so the drop is where the pointer let go
  onDragEnded ( end : CdkDragEnd, job : BookingDiaryUnassignedJobModel ) : void {
    this.hasJustDragged = true;

    clearTimeout(this.resetTimer);

    this.resetTimer = setTimeout(() => this.hasJustDragged = false, CLICK_SUPPRESS_MS);

    this.jobDropped.emit({
      job,
      point: end.dropPoint
    });
  }

  onJobClick ( job : BookingDiaryUnassignedJobModel ) : void {
    if ( this.hasJustDragged ) {
      return;
    }

    this.jobOpened.emit(job);
  }

  splitTitle ( job : BookingDiaryUnassignedJobModel ) : string {
    return this.translateService.instant('BOOKING_SPACE.DIARY.APPOINTMENT_OF', {
      ordering: job.ordering || 1,
      total   : job.total_splits
    });
  }

  trackJob ( index : number, job : BookingDiaryUnassignedJobModel ) : string {
    return job.id;
  }
}
